import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type { User, UserVariables } from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<UserVariables, null>) {
  const { variables } = params;

  const {
    locator,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  const search = {
    uid,
    cid,
    id: uid,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/User${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<UserVariables, null>({
  schema,
  dataPath: 'user',
  verb: requestVerbs.GET,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  keySelector: variables => variables.locator.descriptor.uid,

  parentKeySelector: variables => variables.locator.descriptor.uid,
});

export const fetchResponseContract = createResponseContract<
  UserVariables,
  null,
  User,
  User,
  User
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.ENTITY,

  keySelector: user => user.id,
  processorFn: response => response,
});
